/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Event_View_InvoiceInputs */



/**
* | output |
* | --- |
* | "View invoice" |
*
* @param {Partner_Admin_Commission_Event_View_InvoiceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_event_view_invoice = /** @type {((inputs?: Partner_Admin_Commission_Event_View_InvoiceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Event_View_InvoiceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechnung ansehen")
	return /** @type {LocalizedString} */ ("View invoice")
});